import { EntityStore } from './entity-store'

type SettingsStore = EntityStore<'settings'>

/**
 * Stores settings and preferences objects against given keys.
 */
export const settingsStore: SettingsStore = new EntityStore({
  entityStoreName: 'settings',
})
